import type { AlbumListItem } from '@/lib/api';
import { AlbumCard } from './AlbumCard';

interface AlbumGridProps {
  albums: AlbumListItem[];
  onEdit?: (album: AlbumListItem) => void;
  onDelete?: (album: AlbumListItem) => void;
  isLoading?: boolean;
}

export function AlbumGrid({ albums, onEdit, onDelete, isLoading }: AlbumGridProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="overflow-hidden rounded-lg border bg-card animate-pulse">
            <div className="aspect-[4/3] bg-muted" />
            <div className="p-3">
              <div className="h-5 w-3/4 rounded bg-muted" />
              <div className="mt-2 h-4 w-1/2 rounded bg-muted" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (albums.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="rounded-full bg-muted p-4">
          <svg
            className="h-12 w-12 text-muted-foreground"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            />
          </svg>
        </div>
        <h3 className="mt-4 text-lg font-medium">アルバムがありません</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          最初のアルバムを作成して、写真を整理しましょう。
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {albums.map((album) => (
        <AlbumCard key={album.id} album={album} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
}
